// export const API_URL = "http://localhost:5001/api/v1/";

export const API_URL = "https://stagehrapi.tuhoon.com/api/v1/";
